import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IncomeStreamExclusionReason } from 'src/app/models/Argyle';
import {
  DraftIncomeSource,
  PayFrequency,
  SaveDraftIncomeSourceRequest,
  StreamDecision,
} from 'src/app/models/income-wizard-workflow';
import { PanelDecision } from '../shared/stream-review-question-panel.component';

@Component({
  selector: 'app-stream-review-worknumber',
  templateUrl: './stream-review-worknumber.component.html',
  styleUrls: ['./stream-review-worknumber.component.less'],
})
export class StreamReviewWorknumberComponent {
  @Input() screeningId!: number;
  @Input() applicantName = '';
  @Input() existingDraft: DraftIncomeSource | null = null;
  @Input() exclusionReasons: IncomeStreamExclusionReason[] = [];
  @Output() streamDecision = new EventEmitter<StreamDecision>();

  get suggestedAmount(): number | null {
    return this.existingDraft?.suggestedAmount ?? null;
  }

  onDecision(d: PanelDecision): void {
    const draft: SaveDraftIncomeSourceRequest = {
      draftId: this.existingDraft?.id ?? null,
      wizardStateId: 0,
      screeningId: this.screeningId,
      streamType: this.existingDraft?.streamType ?? 3,
      subType: this.existingDraft?.subType ?? 0,
      streamIdentifier: this.existingDraft?.streamIdentifier ?? '',
      employerName: this.existingDraft?.employerName ?? null,
      incomeAmount: d.action === 'include' ? d.monthlyAmount : 0,
      payFrequency: PayFrequency.Monthly,
      suggestedAmount: this.existingDraft?.suggestedAmount ?? 0,
      notes: d.notes,
      isExcluded: d.action === 'exclude',
      exclusionReasonId: d.action === 'exclude' ? d.exclusionReasonId : null,
    };
    this.streamDecision.emit({ action: d.action, draftSource: draft });
  }
}
